<template>
  <div class="padding-five-all">
    <b-container fluid>
      <b-card class="mb-3">
        <b-row align-v="center">
          <b-col md="6">
            <h4 class="mb-0">Mantenedor de Cronograma de Liquidaciones</h4>
            <small class="text-muted">
              Responsable: Proveedor
            </small>
          </b-col>

          <b-col md="6" class="text-right">
            <b-button variant="primary" @click="nuevoRegistro">
              Nuevo registro
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mb-3">
        <b-form @submit.prevent="guardarCronograma">
          <b-row>
            <b-col md="2">
              <b-form-group label="Año">
                <b-form-input
                  v-model.number="form.anio"
                  type="number"
                  min="2026"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Mes">
                <b-form-select
                  v-model.number="form.mes"
                  :options="meses"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Responsable">
                <b-form-input value="Proveedor" disabled />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="1era fecha - Del">
                <b-form-input
                  v-model="form.primeraFechaDel"
                  type="date"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="1era fecha - Al">
                <b-form-input
                  v-model="form.primeraFechaAl"
                  type="date"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="2da fecha - Del">
                <b-form-input
                  v-model="form.segundaFechaDel"
                  type="date"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="2da fecha - Al">
                <b-form-input
                  v-model="form.segundaFechaAl"
                  type="date"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="6" class="d-flex align-items-end justify-content-end">
              <b-button variant="secondary" class="mr-2" @click="limpiarFormulario">
                Limpiar
              </b-button>

              <b-button type="submit" variant="success" :disabled="isSaving">
                {{ form.id ? "Actualizar" : "Registrar" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>

      <b-card>
        <b-table
          bordered
          hover
          responsive
          show-empty
          :items="cronogramas"
          :fields="fields"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center my-3">
              <b-spinner class="mr-2" />
              <strong>Cargando...</strong>
            </div>
          </template>

          <template #cell(mesDescripcion)="row">
            {{ obtenerNombreMes(row.item.mes) }}
          </template>

          <template #cell(responsable)="row">
            <b-badge variant="info">{{ row.item.responsable }}</b-badge>
          </template>

          <template #cell(primeraFechaDel)="row">
            {{ formatDate(row.item.primeraFechaDel) }}
          </template>

          <template #cell(primeraFechaAl)="row">
            {{ formatDate(row.item.primeraFechaAl) }}
          </template>

          <template #cell(segundaFechaDel)="row">
            {{ formatDate(row.item.segundaFechaDel) }}
          </template>

          <template #cell(segundaFechaAl)="row">
            {{ formatDate(row.item.segundaFechaAl) }}
          </template>

          <template #cell(acciones)="row">
            <b-button
              size="sm"
              variant="warning"
              class="mr-2"
              @click="editarRegistro(row.item)"
            >
              Editar
            </b-button>

           
          </template>
        </b-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "CronogramaLiquidacionesProveedor",

  data() {
    return {
      isBusy: false,
      isSaving: false,
      cronogramas: [],
      form: this.getEmptyForm(),

      meses: [
        { value: 1, text: "Enero" },
        { value: 2, text: "Febrero" },
        { value: 3, text: "Marzo" },
        { value: 4, text: "Abril" },
        { value: 5, text: "Mayo" },
        { value: 6, text: "Junio" },
        { value: 7, text: "Julio" },
        { value: 8, text: "Agosto" },
        { value: 9, text: "Septiembre" },
        { value: 10, text: "Octubre" },
        { value: 11, text: "Noviembre" },
        { value: 12, text: "Diciembre" },
      ],

      fields: [
        { key: "anio", label: "Año", thStyle: { width: "80px" } },
        { key: "mesDescripcion", label: "Mes", thStyle: { width: "120px" } },
        { key: "responsable", label: "Responsable", thStyle: { width: "130px" } },
        { key: "primeraFechaDel", label: "1era Fecha Del" },
        { key: "primeraFechaAl", label: "1era Fecha Al" },
        { key: "segundaFechaDel", label: "2da Fecha Del" },
        { key: "segundaFechaAl", label: "2da Fecha Al" },
        { key: "acciones", label: "Acciones", thStyle: { width: "180px" } },
      ],
    };
  },

  mounted() {
    this.listarCronogramas();
  },

methods: {
  getEmptyForm() {
    return {
      id: null,
      anio: 2026,
      mes: null,
      responsable: "Proveedor",
      primeraFechaDel: "",
      primeraFechaAl: "",
      segundaFechaDel: "",
      segundaFechaAl: "",
    };
  },

  formatDate(value) {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY");
  },

  obtenerNombreMes(mes) {
    const item = this.meses.find(x => x.value === Number(mes));
    return item ? item.text : "";
  },

  nuevoRegistro() {
    this.form = this.getEmptyForm();
  },

  limpiarFormulario() {
    this.form = this.getEmptyForm();
  },

  editarRegistro(item) {
    this.form = {
      id: item.id,
      anio: Number(item.anio),
      mes: Number(item.mes),
      responsable: item.responsable || "Proveedor",
      primeraFechaDel: this.toInputDate(item.primeraFechaDel),
      primeraFechaAl: this.toInputDate(item.primeraFechaAl),
      segundaFechaDel: this.toInputDate(item.segundaFechaDel),
      segundaFechaAl: this.toInputDate(item.segundaFechaAl),
    };
  },

  toInputDate(value) {
    if (!value) return "";
    return moment(value).format("YYYY-MM-DD");
  },

  validarFormulario() {
    if (!this.form.anio || !this.form.mes) {
      this.mostrarError("Debe ingresar año y mes.");
      return false;
    }

    if (
      !this.form.primeraFechaDel ||
      !this.form.primeraFechaAl ||
      !this.form.segundaFechaDel ||
      !this.form.segundaFechaAl
    ) {
      this.mostrarError("Debe completar todas las fechas.");
      return false;
    }

    if (moment(this.form.primeraFechaDel).isAfter(this.form.primeraFechaAl)) {
      this.mostrarError("La 1era fecha 'Del' no puede ser mayor que 'Al'.");
      return false;
    }

    if (moment(this.form.segundaFechaDel).isAfter(this.form.segundaFechaAl)) {
      this.mostrarError("La 2da fecha 'Del' no puede ser mayor que 'Al'.");
      return false;
    }

    return true;
  },

  async listarCronogramas() {
    try {
      this.isBusy = true;

      const response = await axios.get(
        process.env.VUE_APP_REPORT_VTEX_BASE+"/hp/service-system/v1/cronograma-liquidaciones",
        {
          params: {
            anio: 2026,
            responsable: "Proveedor",
          },
        }
      );

      this.cronogramas = response.data || [];
    } catch (error) {
      console.error("Error al listar cronogramas", error);
      this.mostrarError("No se pudo cargar el cronograma.");
    } finally {
      this.isBusy = false;
    }
  },

  async guardarCronograma() {
    if (!this.validarFormulario()) return;

    try {
      this.isSaving = true;

      const payload = {
        anio: this.form.anio,
        mes: this.form.mes,
        responsable: "Proveedor",
        primeraFechaDel: this.form.primeraFechaDel,
        primeraFechaAl: this.form.primeraFechaAl,
        segundaFechaDel: this.form.segundaFechaDel,
        segundaFechaAl: this.form.segundaFechaAl,
      };

      if (this.form.id) {
        await axios.put(
          process.env.VUE_APP_REPORT_VTEX_BASE+`/hp/service-system/v1/cronograma-liquidaciones/${this.form.id}`,
          payload
        );
        this.mostrarExito("Cronograma actualizado correctamente.");
      } else {
        await axios.post(
          process.env.VUE_APP_REPORT_VTEX_BASE+"/hp/service-system/v1/cronograma-liquidaciones",
          payload
        );
        this.mostrarExito("Cronograma registrado correctamente.");
      }

      this.limpiarFormulario();
      this.listarCronogramas();
    } catch (error) {
      console.error("Error al guardar cronograma", error);
      this.mostrarError("No se pudo guardar el cronograma.");
    } finally {
      this.isSaving = false;
    }
  },

  async eliminarRegistro(item) {
    const ok = window.confirm(
      `¿Deseas eliminar el cronograma de ${this.obtenerNombreMes(item.mes)} ${item.anio}?`
    );

    if (!ok) return;

    try {
      await axios.delete(
        process.env.VUE_APP_REPORT_VTEX_BASE+`/hp/service-system/v1/cronograma-liquidaciones/${item.id}`
      );
      this.mostrarExito("Cronograma eliminado correctamente.");
      this.listarCronogramas();
    } catch (error) {
      console.error("Error al eliminar cronograma", error);
      this.mostrarError("No se pudo eliminar el cronograma.");
    }
  },

  mostrarExito(mensaje) {
    this.$bvToast.toast(mensaje, {
      title: "Éxito",
      variant: "success",
      solid: true,
    });
  },

  mostrarError(mensaje) {
    this.$bvToast.toast(mensaje, {
      title: "Error",
      variant: "danger",
      solid: true,
    });
  },
}
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>